module.exports = __webpack_public_path__ + "img/6T.a606eb9b.png";